import { Root } from "react-dom/client"

// Clicking between tabs reloads the fields.
// When that happens, scripting reloads the value of the RTF field,
// which causes the iframes within the RTF fields to retrigger and reinitialize
// the components.
//
// As this skips the unmounting of the React components,
// this results the component could be initialized multiple times,
// although only one is visible.
const registeredRoots = new Map<string, Root>()

const RootRegistry = {
    add(id: string, root: Root): void {
        // if a root already exists for this id, clean it up first
        const existing = registeredRoots.get(id)

        // if it's reregistered, we have to remove the previous one
        if (existing) {
            existing.unmount()
        }

        registeredRoots.set(id, root)
    },

    remove(id: string): void {
        const root = registeredRoots.get(id)

        // clean up before removing
        if (root) {
            root.unmount()
            registeredRoots.delete(id)
        }
    },

    get(id: string): Root | undefined {
        return registeredRoots.get(id)
    },

    clear(): void {
        // we have to ensure they are unmounted first
        for (const root of registeredRoots.values()) {
            root.unmount()
        }
        registeredRoots.clear()
    },
}

export default RootRegistry
